import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPaymentUser } from '../../../apis/payments/users';
import { RequestStatus } from '../../../enums';
import { PaymentUser } from '../../../types/userType';

interface PaymentUserState {
  paymentUser?: PaymentUser;
  isLoading: boolean;
  paymentUserStatus?: RequestStatus;
}

const initialState: PaymentUserState = {
  paymentUser: undefined,
  isLoading: false,
  paymentUserStatus: undefined
};

const fetchPaymentUser = createAsyncThunk(
  'paymentUser/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const user = await getPaymentUser();
      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const paymentUserSlice = createSlice({
  name: 'paymentUser',
  initialState,
  reducers: {
    clearPaymentUserState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentUser.pending, (state) => {
        state.isLoading = true;
        state.paymentUserStatus = RequestStatus.LOADING;
      })
      .addCase(fetchPaymentUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentUser = action.payload;
        state.paymentUserStatus = RequestStatus.SUCCESS;
      })
      .addCase(fetchPaymentUser.rejected, (state) => {
        state.isLoading = false;
        state.paymentUser = undefined;
        state.paymentUserStatus = RequestStatus.FAILED;
      });
  }
});

export const { clearPaymentUserState } = paymentUserSlice.actions;
export { fetchPaymentUser };
export default paymentUserSlice;
